import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=52611c67&"
import script from "./Textarea.vue?vue&type=script&lang=ts&"
export * from "./Textarea.vue?vue&type=script&lang=ts&"
import style0 from "./Textarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3194833414/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52611c67')) {
      api.createRecord('52611c67', component.options)
    } else {
      api.reload('52611c67', component.options)
    }
    module.hot.accept("./Textarea.vue?vue&type=template&id=52611c67&", function () {
      api.rerender('52611c67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/form/textarea/Textarea.vue"
export default component.exports